<template>
  <div>
    <div class="nav-title">{{ $t("tenantManage") }}</div>

    <div class="setting-nav-container">
      <el-menu :default-active="activeMenu" router class="setting-sider">
        <el-menu-item index="/tenant/tenant">
          <template slot="title"> {{ $t("tenant") }} </template>
        </el-menu-item>

        <el-menu-item index="/tenant/tenantType">
          <template slot="title">
            {{ $t("tenantType") }}
          </template>
        </el-menu-item>

        <el-menu-item index="/tenant/tenantConfig">
          <template slot="title">
            {{ $t("tenantConfig") }}
          </template>
        </el-menu-item>

        <el-menu-item index="/tenant/CreditCardConfig">
          <template slot="title">
            {{ $t("CreditCardConfig") }}
          </template>
        </el-menu-item>
      </el-menu>

      <div class="setting-view">
        <div class="view-container">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    activeMenu() {
      return this.$route.path;
    }
  }
};
</script>
<style scoped>
.setting-nav-container {
  display: block;
}

.setting-sider {
  float: left;
  width: 260px;
}

.setting-view {
  margin-left: 280px;
  padding-left: 0;
  display: block;
}
</style>
